import type { SubCondition } from './HubOptionState.types';
import { ConditionQuantifier } from './HubOptionState.types';

export type IconCondition = {
  uuid: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
  resultIconId: number | null;
};

export const HUB_MAX_ICON_CONDITIONS = 5;
